Component({
  properties: {
    type: {
      type: String,
      value: 'primary'
    },
  },
  data: {
  }
})
